import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer } from 'react-router-dom'
import useStockStore from '../../store'
import { initialState } from './slice'
import { parseSortModelToParamString } from '$components/common'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Order History loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Order History loader')

  useStockStore.getState().resetPurchaseOrderHistorySlice()

  // Create a single promise that calls the API once
  const getPurchaseOrders = useStockStore
    .getState()
    .getPurchaseOrdersPaginated({
      start: initialState.purchaseOrderHistoryFilters.from,
      end: initialState.purchaseOrderHistoryFilters.to,
      page: useStockStore.getState().purchaseOrderPaginationModel.page,
      pageSize: useStockStore.getState().purchaseOrderPaginationModel.pageSize,
      sort: parseSortModelToParamString(
        useStockStore.getState().purchaseOrderSortModel
      ),
    })
  const getSuppliers = useStockStore.getState().getSuppliers()

  // Return a deferred promise to enable React Router's built-in loading state
  return defer({
    data: Promise.all([getPurchaseOrders, getSuppliers])
      .then(() => true)
      .catch((error) => {
        logger.error('Loader Order History error: ', error)
        return false
      }),
  })
}
